<template>
  <div class="need-review-container">
    <h5>{{ title }}</h5>
    <label for="">Catatan:</label>
    <input class="mb20" type="textarea" v-model="catatan" />
    <div class="d-flex justify-content-center">
      <button class="btn-landing" @click="modalClose">Close</button>
      <button class="btn-landing" @click="submit(catatan)">Submit</button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['modalClose', 'submit', 'title'],
  data() {
    return {
      catatan: '',
    }
  },
}
</script>
